<template>
  <div class="profile-dropdown d-flex align-items-center justify-content-center">
    <b-dropdown>
      <template #button-content>
        <avatar v-if="$auth.isAuthenticated" class="avatar" :username="username"></avatar>
      </template>
      <b-dropdown-header class="profile-dropdown--header" v-if="$auth.isAuthenticated">
        <h5>{{ currentUser.fname }} {{ currentUser.lname }}</h5>
      </b-dropdown-header>
      <b-dropdown-divider />
      <b-dropdown-item class="profile-dropdown--item" to="/user/profile">
        <b-icon-person-circle class="mr-2" />&nbsp;Profile
      </b-dropdown-item>
      <b-dropdown-item class="profile-dropdown--item" v-if="currentAgency && $permission('admin:agency')" to="/admin">
        <font-awesome-icon class="mr-2" icon="fa-cog" />&nbsp;&nbsp;Admin
      </b-dropdown-item>
      <b-dropdown-item class="profile-dropdown--item" v-if="$permission('developer')"
        :href="`https://developer.convey911.com?agencyId=${currentAgency.agency_id}&agencySecret=${currentAgency.agency_secret}`"
        target="_blank">
        <font-awesome-icon class="mr-2" icon="fa-code" />&nbsp;Developer
      </b-dropdown-item>
      <b-dropdown-item class="profile-dropdown--item" v-if="$permission('developer') && currentAgency.agency_secret"
        :href="`${cdnHostUrl}/?callSimulator=true&agencyId=${currentAgency.agency_id}&agencySecret=${currentAgency.agency_secret}`"
        target="_blank">
        <font-awesome-icon class="mr-2" icon="fa-circle-play" />&nbsp;&nbsp;Call Simulator
      </b-dropdown-item>
      <b-dropdown-divider />
      <b-dropdown-item class=" profile-dropdown--item" @click="$emit('logout')">
        <font-awesome-icon class="mr-3" icon="power-off" />Log out
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
/* eslint-disable */
import { mapState, mapGetters } from "vuex";
import Avatar from "vue-avatar";
import LightDarkModeSelector from "@/components/LightDarkModeSelector";
import VolumeController from "@/components/VolumeController";

export default {
  name: "ProfileDropDown",
  components: {
    Avatar,
    LightDarkModeSelector,
    VolumeController,
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.user.user,
    }),
    ...mapGetters("agency", ["currentAgency", "agencySettings"]),
    ...mapGetters("user", ["isMobile"]),
    username() {
      return `${this.currentUser.fname} ${this.currentUser.lname}`;
    },
  },
  data() {
    return {
      cdnHostUrl: process.env.VUE_APP_CONVEY_SDK_HOST
    };
  }
};
</script>

<style lang="scss">
.profile-dropdown {
  width: 100%;
  height: 100%;

  .b-dropdown {
    >button {
      padding: 0 !important;
      background: transparent !important;
      border: none !important;
      &::after {
        display: none !important;
      }
    }
  }

  &--header {
    h5 {
      margin: 0;
    }
  }
}
</style>
